export default __webpack_public_path__ + "static/media/t2.58315458.jpg";